function Conversation() {
	this.id = null;
	this.name = null;
	this.users = [];
	this.messages = [];
	this.hasOnlineUsers = false;
	this.active = null;
	this.unreadMessageCount = null;
	this.lastMessage = null;
	this.createdAt = null;
	this.initial = null;
	this.messagesLoading = false;
	this.messageToSend = null;
	this.messageSending = null;
	this.nextPage = 2;

	this.init = function () {
		this.setInitial();
		this.updateLastMessage();
		this.updateUnreadMessageCount();
	};

	this.setInitial = function () {
		this.initial = this.users[0].initial;
	};

	this.updateLastMessage = function () {
		if (this.messages !== null) {
			this.lastMessage = this.messages[this.messages.length - 1];
		} else {
			this.lastMessage = null;
		}
	};

	this.updateUnreadMessageCount = function () {
		let unreadMessageCount = 0;
		angular.forEach(this.messages, function (message, key) {
			if (!message.read) {
				unreadMessageCount++;
			}
		});
		this.unreadMessageCount = unreadMessageCount;
	};
}